<template>
  <div :class="['cf-page-banner', { 'cf-page-banner--alt' :isAlternateStyle }]">
    <slot name="override-default-slot">
      <h3 class="cf-page-banner__content">
        <slot />
      </h3>
    </slot>
  </div>
</template>


<script>
  export default {
    name: 'CfPageBanner',

    props: {
      content: {
        type: String,
        default: ''
      },

      isAlternateStyle: {
        type: Boolean,
        default: false
      }
    }
  };
</script>
